export default {
  'site.name': '爆料网',
  'site.slogan': '实时追踪全网黑料与网红塌房现场',
  'site.tagline': '吃瓜群众必备的每日爆料平台',
  'nav.home': '首页',
  'nav.categories': '分类',
  'nav.about': '关于我们',
  'nav.hot': '热门',
  'footer.copyright': '© 2026 爆料网 版权所有',
  'footer.disclaimer': '本站内容来源于网络，如有侵权请联系删除。',
  'footer.follow': '关注我们',
  'footer.newsletter': '订阅每日爆料',
  'footer.newsletterDesc': '第一时间接收最新爆料推送',
  'footer.subscribe': '订阅',
  'footer.emailPlaceholder': '输入邮箱地址',
  'footer.links': '快速链接',
  'footer.categories': '爆料分类',
  'footer.about': '关于本站',
  'footer.privacy': '隐私政策',
  'footer.terms': '使用条款',
  'footer.contact': '联系我们',
  'breadcrumb.home': '首页',
  'seo.title': '爆料网 - 911爆料网与51爆料网 | 每日吃瓜与网红黑料独家追踪',
  'seo.description': '爆料网实时追踪全网黑料与网红塌房现场，覆盖911爆料网、51爆料网与91爆料网等核心入口的独家吃瓜猛料。每日更新娱乐圈内幕、明星八卦及热门事件，是吃瓜群众获取最新反差视频与在线爆料的必备站点。',
  'seo.keywords': '爆料网,911爆料网,51爆料网,91爆料网,娱乐爆料网,吃瓜爆料,网红黑料,每日爆料,独家爆料,八卦爆料网',
};